<template>
  <div class="alert">
    <div class="alert__modal">
      <div class="alert__container">
        <button v-if="showClose" @click="$emit('close-modal')" class="alert__close">
          <CloseModalXIcon class="alert__close--icon" />
        </button>
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
import CloseModalXIcon from '@/assets/icons/close_modal_x.svg'

export default {
  name: 'AlertModal',
  components: {
    CloseModalXIcon: { ...CloseModalXIcon, name: 'CloseModalXIcon' },
  },
  props: {
    showClose: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
<style lang="scss" scoped>
.alert {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 220;
  overflow-y: scroll;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(17.5px);
  display: flex;
  justify-content: center;
  align-items: center;
  &__modal {
    overflow: hidden;
    background: var(--dark-brighter);
    border-radius: 24px;
  }
  &__container {
    position: relative;
    background: var(--glass-mid-gray);
    padding: 30px;
    min-height: 400px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: auto 0;
    max-height: 90vh;
    overflow: auto;
  }
  &__title {
    text-align: center;
    font: normal normal bold var(--font-medium);
    font-size: rem(40px);
    line-height: rem(52px);
    letter-spacing: 0px;
    color: var(--white);
  }
  &__subtitle {
    text-align: center;
    font-size: rem(18px);
    line-height: rem(24px);
    font-weight: 500;
    color: var(--light-blue-gray);
    max-width: 800px;
  }
  &__textarea {
    background: #eaeaea 0% 0% no-repeat padding-box;
    border-radius: 13px;
    width: 100%;
    min-height: 200px;
    padding: 30px;
    border: 0px;
  }
  &__close {
    position: absolute;
    right: 0;
    top: 0;
    background: none;
    border: none;
    cursor: pointer;
    margin: 30px;
    &--icon {
      stroke: var(--white);
    }
  }
}
</style>
